import request from './request'

export function traceGenealogy(data) {
  return request.post('/inventory/genealogy/trace', data)
}
export function traceGenealogyTree(data) {
  return request.post('/inventory/genealogy/trace-tree', data)
}
